export default __webpack_public_path__ + "static/media/bg-sub.26b33b8b.png";